import { useEffect, useState } from "react";
import { gql } from "@apollo/client";

import { useQuery } from "@apollo/client/react";
import { ProviderTypeHookQuery } from "@/__generated__/graphql";

export const GET_PROVIDER_TYPE = gql(`
    query ProviderTypeHook {
        provider {
            providerId
            type
        }
    }
`);

export function useIsEnterpriseProvider() {
  const [isEnterpriseProvider, setIsEnterpriseProvider] = useState(true);
  const { loading: providerTypeQueryLoading, data: providerTypeData } =
    useQuery<ProviderTypeHookQuery>(GET_PROVIDER_TYPE, {
      fetchPolicy: "no-cache",
    });

  useEffect(() => {
    if (!providerTypeQueryLoading && providerTypeData?.provider) {
      setIsEnterpriseProvider(
        providerTypeData.provider.type === "enterprise_provider",
      );
    }
  }, [providerTypeQueryLoading, providerTypeData]);

  return isEnterpriseProvider;
}
